import { type Node } from 'datocms-structured-text-utils';
import { type StructuredTextGraphQlResponse } from 'react-datocms';

export const createStructuredContent = (
  str: string
): StructuredTextGraphQlResponse => ({
  value: {
    document: {
      children: [
        {
          type: 'paragraph' as const,
          children: [{ type: 'span' as const, value: str }],
        },
      ],
      type: 'root' as const,
    },
    schema: 'dast' as const,
  },
});

export const replaceStructuredText = (
  textObject: StructuredTextGraphQlResponse,
  pattern: string,
  replacement: string
): StructuredTextGraphQlResponse => {
  const replaceInNode = <N extends Node>(dastNode: N): N => {
    // Replace the text if this node contains text
    if ('value' in dastNode) {
      const value = dastNode.value.replace(pattern, replacement);
      return { ...dastNode, value };
    }

    // Replace the text in each child if this node has children
    if ('children' in dastNode) {
      const children = dastNode.children.map(replaceInNode);
      return { ...dastNode, children };
    }

    // Otherwise return a copy of the node unchanged
    return { ...dastNode };
  };

  const { value } = textObject;
  const document = replaceInNode(value.document);
  return { ...textObject, value: { ...value, document } };
};
